import {
    setScanCardCarrier,
    editCarrier,
    editPlan,
    selectFirstCarrierAndPlan,
} from '../ScanCardActions';
import { getCarrierAndPlan } from '../ScanCardActionsHelpers';
import { getScanCardState } from '../../../data/scan-card/scanCardSelector';
import { connect } from 'react-redux';
import ScanCardResultsView from './ScanCardResultsView';

export function mapStateToProps(state) {
    const cardState = getScanCardState(state);

    return getCarrierAndPlan(cardState);
}

export const mapDispatchToProps = {
    setScanCardCarrier,
    editCarrier,
    editPlan,
    selectFirstCarrierAndPlan,
};

export const ScanCardResultsConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(ScanCardResultsView);
